// src/pages/UpdatePayment.jsx
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import NonAuthLayout from "../../Layout/NonAuthLayout";
import { Save, ArrowLeft, Loader2 } from "lucide-react";
import {
  GetSingleInvoiceThunk,
  UpdateInvoiceThunk,
} from "../../redux/states/payments/thunk";
import toast from "react-hot-toast";

const UpdatePayment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { uuid } = useParams();

  const { singlePayment, loading, error } = useSelector(
    (state) => state.payments
  );
  console.log(singlePayment)

  const [formData, setFormData] = useState({
    order_id: "",
    amount: "",
    method: "",
    transaction_id: "",
    payment_date: "",
    payment_status: "pending",
    remarks: "",
  });

  // Load single payment
  useEffect(() => {
    if (uuid) {
      dispatch(GetSingleInvoiceThunk(uuid));
    }
  }, [dispatch, uuid]);

  // Populate form when data comes
  useEffect(() => {
    if (singlePayment) {
      setFormData({
        order_id: singlePayment.order_id || "",
        amount: singlePayment.amount || "",
        method: singlePayment.method || "",
        transaction_id: singlePayment.transaction_id || "",
        payment_date: singlePayment.payment_date
          ? new Date(singlePayment.payment_date).toISOString().slice(0, 10)
          : "",
        payment_status: singlePayment.payment_status || "pending",
        remarks: singlePayment.remarks || "",
      });
    }
  }, [singlePayment]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await dispatch(UpdateInvoiceThunk({ uuid, formData })).unwrap();
      toast.success("Payment updated successfully!");
      navigate("/payments");
    } catch (err) {
      console.error(err);
      toast.error("Failed to update payment");
    }
  };

  return (
    <NonAuthLayout>
      <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-12xl mx-auto">
          {/* Header */}
          <div className="flex justify-between items-center mb-8">
            <h1 className="text-3xl font-bold text-gray-800">Update Payment</h1>
            <button
              onClick={() => navigate(-1)}
              className="flex items-center gap-2 text-gray-600 hover:text-blue-600 transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Go Back
            </button>
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-6">
              <p className="text-red-600">{error}</p>
            </div>
          )}

          <form
            onSubmit={handleSubmit}
            className="space-y-6 bg-white rounded-2xl shadow-sm border border-gray-200 p-6"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Order ID
                </label>
                <input
                  type="text"
                  name="order_id"
                  value={formData.order_id}
                  onChange={handleChange}
                  className="mt-1 block w-full border-gray-300 rounded-xl shadow-sm"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Amount
                </label>
                <input
                  type="number"
                  name="amount"
                  value={formData.amount}
                  onChange={handleChange}
                  className="mt-1 block w-full border-gray-300 rounded-xl shadow-sm"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Payment Method
                </label>
                <input
                  type="text"
                  name="payment_method"
                  value={formData.method}
                  onChange={handleChange}
                  className="mt-1 block w-full border-gray-300 rounded-xl shadow-sm"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Transaction ID
                </label>
                <input
                  type="text"
                  name="transaction_id"
                  value={formData.transaction_id}
                  onChange={handleChange}
                  className="mt-1 block w-full border-gray-300 rounded-xl shadow-sm"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Payment Date
                </label>
                <input
                  type="date"
                  name="payment_date"
                  value={formData.payment_date}
                  onChange={handleChange}
                  className="mt-1 block w-full border-gray-300 rounded-xl shadow-sm"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Payment Status
                </label>
                <select
                  name="payment_status"
                  value={formData.payment_status}
                  onChange={handleChange}
                  className="mt-1 block w-full border-gray-300 rounded-xl shadow-sm"
                >
                  <option value="pending">Pending</option>
                  <option value="completed">Completed</option>
                </select>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">
                Remarks
              </label>
              <textarea
                name="remarks"
                value={formData.remarks}
                onChange={handleChange}
                rows="3"
                className="mt-1 block w-full border-gray-300 rounded-xl shadow-sm"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full flex justify-center items-center gap-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-4 px-6 rounded-xl transition-all duration-300 disabled:opacity-50"
            >
              {loading ? (
                <Loader2 className="w-5 h-5 animate-spin" />
              ) : (
                <Save className="w-5 h-5" />
              )}
              Update Payment
            </button>
          </form>
        </div>
      </div>
    </NonAuthLayout>
  );
};

export default UpdatePayment;
